<template>
  <div class="login-form">
    <a-form :model="formPhone">
      <a-form-item v-bind="validateInfos.phone">
        <a-input class="login-input" type="tel" :maxLength="11" v-model:value="formPhone.phone"
          :placeholder="t('login.placeholderStr3')">
          <template #prefix>
            <mobile-outlined style="margin-right: 15px" />
          </template>
        </a-input>
      </a-form-item>
      <a-form-item v-bind="validateInfos.msgCode">
        <a-row class="login-input">
          <a-col :span="11">
            <a-input type="tel" :maxLength="6" v-model:value="formPhone.msgCode" class="login-input"
              :placeholder="t('login.placeholderStr4')"></a-input>
          </a-col>
          <a-col :span="12">
            <a-button type="primary" :disabled="Disabled" @click="getMsg">{{ Disabled ? btnTxt : verificationCode
              }}</a-button>
          </a-col>
        </a-row>
      </a-form-item>
    </a-form>
    <slot name="login"></slot>
  </div>
</template>

<script lang="ts">
import {
  MobileOutlined,
} from "@ant-design/icons-vue";
import { defineComponent, ref, reactive, computed } from "vue";
import { getSms } from "@/utils/api";
import { message as Message } from "ant-design-vue";
import { countDown, debounce } from "@/utils/common";
import { Form } from "ant-design-vue";
import { rulesloginPhoneRef } from "@/utils/validate";
import { useStore } from "vuex"
import { useI18n } from 'vue-i18n'

const useForm = Form.useForm;
interface FormPhone {
  msgCode: string;
  phone: string;
}
export default defineComponent({
  components: {
    MobileOutlined,
  },
  setup() {
    const { t } = useI18n()
    const formPhone = reactive<FormPhone>({ msgCode: "", phone: "" });
    const Disabled = ref(false)
    const store = useStore();
    const btnTxt = ref('')
    const verificationCode = computed(() => {
      return t('login.verificationCode')
    })
    const getMsg = debounce(async () => {
      if (!/^1[3456789]\d{9}$/.test(formPhone.phone)) {
        Message.error(t('iphone.warnStr1'));
        return
      }
      await getSms({ baseUrl: store.getters['getBaseUrl'], phone: formPhone.phone });
      Message.success(t('iphone.warnStr2'));
      countDown(60, (time: any) => {
        time ? btnTxt.value = `${t('iphone.warnStr3')}（${time}）` : btnTxt.value = `${t('iphone.warnStr3')}`
        time ? Disabled.value = true : Disabled.value = false
      })
    }, 500);
    const loginPlatform = () => {
      return new Promise((reslove) => {
        validate().then(() => {
          reslove(formPhone)
        })
      })
    };

    const { validate, validateInfos } = useForm(formPhone, rulesloginPhoneRef); // 用户名密码
    return {
      formPhone,
      getMsg,
      loginPlatform,
      validate,
      validateInfos,
      btnTxt,
      Disabled,
      verificationCode,
      t
    };
  },
});
</script>
<style scoped lang="less" src="@/style/common.less"></style>
